import {send} from "./http";
import {TokenSet} from "./models";

// POST /token: signing in, renewing and signing out (tristar-corp-api TokensRouteHandler).
export const AuthApi = {
    login: (username: string, password: string, deviceId: string) =>
        send<TokenSet>('POST', '/token', { grant_type: 'password', username, password, untrusted_device_id: deviceId }),

    refresh: (refreshToken: string, deviceId: string) =>
        send<TokenSet>('POST', '/token', { grant_type: 'refresh_token', refresh_token: refreshToken, untrusted_device_id: deviceId }),

    logout: (accessToken: string) =>
        send<void>('POST', '/token', { grant_type: 'remove', access_token: accessToken })
};
